<template>
    <div class="card shadow-sm mb-3">
        <div class="card-header border-bottom py-3 px-3 px-md-4 d-flex align-items-center justify-content-between flex-wrap gap-2">
            <div class="d-flex align-items-center gap-2">
                <span class="cal-header-icon cal-header-icon--blue">
                    <i class="bi bi-exclamation-octagon"></i>
                </span>
                <div>
                    <h6 class="mb-0 fw-bold">İstisnalar</h6>
                    <small class="text-muted" style="font-size: 0.78rem;">Sığorta təminatına daxil olmayan hallar</small>
                </div>
            </div>
            <div class="d-flex align-items-center gap-2">
                <button type="button" class="btn action-btn action-btn--success" @click="OpenDialog(0, false, null, 'LIST')">
                    <i class="bi bi-plus-lg me-1"></i>
                    <span>Təzə yazı</span>
                </button>
                <button type="button" class="btn action-btn action-btn--muted" @click="GetLists">
                    <i class="bi bi-arrow-clockwise me-1"></i>
                    <span>Yeniləmək</span>
                </button>
            </div>
        </div>
        <div class="card-body p-0" v-loading="loading">
            <Table :priv="priv" @open-dialog="OpenDialog" @get-data="GetLists" :data="data"></Table>
        </div>
    </div>

    <el-dialog :close-on-click-modal="false" v-model="this.list.dialogVis" width="35%" style="margin-top: 3%;"
        :title="this.editing ? 'İstisna dəyişilməsi' : 'Yeni istisna'" modal-class="modal-class" :destroy-on-close="true">
        <list-dialog :object="list.object" :editing="editing" @close-dialog="this.list.dialogVis = false"
            @insert-dialog="Insert"></list-dialog>
    </el-dialog>
</template>
<script>
import Table from "./Components/Tables/Table.vue";
import ListDialog from "./Components/Dialogs/ListDialog.vue";


export default {
    components: {
        Table,
        ListDialog
    },
    props: {
        priv: Object
    },
    data() {
        return {
            loading: null,
            data: [
                {
                    id: 1,
                    exceptName: "İntihar (adətən müqavilənin ilk 12–24 ayı ərzində)",
                    created: "01.07.2025 14:32",
                    updated: "05.07.2025 10:15"
                },
                {
                    id: 2,
                    exceptName: "Müharibə, hərbi əməliyyatlar, terror aktları",
                    created: "02.07.2025 09:05",
                    updated: "06.07.2025 12:40"
                },
                {
                    id: 3,
                    exceptName: "Cinayət törədərkən ölüm",
                    created: "03.07.2025 17:22",
                    updated: "07.07.2025 08:55"
                },
                {
                    id: 4,
                    exceptName: "Alkoqol/narkotik sərxoşluğu",
                    created: "03.07.2025 17:22",
                    updated: "07.07.2025 08:55"
                }
            ],
            loading2: null,
            data2: [],
            list: {
                dialogVis: false,
                object: null
            },
        }
    },
    methods: {
        GetLists() {

            //None
        },
        GetLists2() {
            this.loading2 = true
            //None
        },
        Insert() {
            if (this.type == 'LIST') {
                this.list.dialogVis = false
                this.GetLists()
            }
        },
        OpenDialog(index, edit, object, type) {
            this.type = type
            this.list.constindex = index
            if (type == 'LIST') {
                this.list.constindex = index
                this.list.dialogVis = true
                this.list.object = object
            }
            this.editing = edit
        }
    },
    mounted() {
        this.GetLists()
        this.GetLists2()
    }
}
</script>